import { BackstageConfig } from './Backstage';
import { BackstageProvider } from './provider';

const IS_PROD = process.env.NODE_ENV === 'production';

interface BackstageLocalProviderOptions {
  config: BackstageConfig;
}

const BackstageLocalProvider: BackstageProvider<BackstageLocalProviderOptions> =
  (priority = 0, options) =>
  () => {
    return {
      name: 'backstage-local',
      priority,
      get: async () => {
        if (IS_PROD) return {};
        const { config = {} } = options;
        return config;
      }
    };
  };

export default BackstageLocalProvider;
